import React from 'react'
import PropTypes from 'prop-types'
import IframeViewer from 'components/IframeViewer'
import Heading from 'components/Heading'
import constants from 'constants'

class DetailedReportView extends React.Component {
  static propTypes = {
    currentReportId: PropTypes.string.isRequired,
    currentReportURL: PropTypes.string.isRequired,
    reports: PropTypes.object.isRequired,
  }

  render() {
    const reportUrl = `${constants.SSRS_BASEURL}${this.props.currentReportURL}`
    // const header = this.props.reports.reports.filter(rpt => rpt.ID === this.props.currentReportId).map(rpt => rpt.Name)
    const header = this.props.reports.reports
      .filter((rpt) => {
        const rptId = rpt && rpt.ID ? rpt.ID.toString().trim().toLowerCase() : ''
        const currentId = this.props.currentReportId ? this.props.currentReportId.toString().trim().toLowerCase() : ''
        return rptId === currentId
      })
      .map(rpt => rpt.Name)
    return (
      <div style={{ minWidth: '1270px' }}>
        <Heading noTopPadding>{header}</Heading>
        <IframeViewer
          title="Reports"
          url={reportUrl}
        />
      </div>
    )
  }
}

export default DetailedReportView



// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/DetailedReport.js